import { SENDTOLIST_SEARCH, SENDTOLIST_PAGE } from '../actions/sendtolistactions';

const state = { search: '', page: 0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [SENDTOLIST_SEARCH]: ({ commit }, search) => {
        commit(SENDTOLIST_SEARCH, search);
    },
    [SENDTOLIST_PAGE]: ({ commit }, page) => {
        commit(SENDTOLIST_PAGE, page);
    }
};

const mutations = {
    [SENDTOLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [SENDTOLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};